import type { CloudGraphPullRequestEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI: CloudGraphPullRequestEntityAti[] =
	['ati:cloud:graph:pull-request'];
